import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Switch from '../../Part_Sample/Switch';
import Editbox from '../../Part_Sample/Editbox';
import Dropdown from '../../Part_Sample/Dropdown';
import Icon_Carousel from '../../Part_Sample/Icon_Carousel';
import { isEmpty, getIcon, getSceneIcon, getPointIconList } from '../../Common/Common';

import Target_Cell from '../../Layout/Components/Target_Cell';

import trend_icon from '../../../Images/Daikin_Images/image/TrendGraph.png';
import energy_icon from '../../../Images/Daikin_Images/image/EnergyManagement.png';
import water_icon from '../../../Images/Daikin_Images/image/WaterManagement.png';
import op_info_icon from '../../../Images/Daikin_Images/image/OperationManagement.png';
import error_info_icon from '../../../Images/Daikin_Images/image/ErrorManagement.png';

import check from '../../../Images/Icons/check.png';

export default class Edit_Layout extends Component {
	constructor(props) {
		super(props);

		window.app.showLoading();

		let grouplist = {};

		if (!isEmpty(this.props.param.groups)) {
			Object.keys(this.props.param.groups).map((groupId) => {
				grouplist[groupId] = false;
			});
		}

		let scenelist = {};

		if (!isEmpty(this.props.param.scenes)) {
			Object.keys(this.props.param.scenes).map((sceneId) => {
				scenelist[sceneId] = false;
			});
		}

		let layoutlist = {};

		if (!isEmpty(this.props.param.layouts)) {
			Object.keys(this.props.param.layouts).map((layoutId) => {
				if (layoutId != this.props.param.layout_id) {
					layoutlist[layoutId] = false;
				}
			});
		}

		let devicelist = {};

		if (!isEmpty(window.app.state.point_list)) {
			Object.keys(window.app.state.point_list).map((pointId) => {
				let pointInfo = window.app.state.point_list[pointId];
				if (!isEmpty(pointInfo)) {
					devicelist[pointId] = false;
				}
			})
		}

		let reportlist = {
			trend: false,
			energy_management: false,
			water_management: false,
			op_info: false,
			error_info: false
		};

		let icon_list = getPointIconList();
		let layoutId = this.props.param.layout_id;																//get existing layoutId
		let base64ImageId = null;
		let base64Image = null;
		let acsummarySelected = false;
		let powersummarySelected = false;
		let layoutInfo = {
			name: "",
			icon: "",
			bgImage: "",
			target: []
		};


		if (layoutId != null) {																					//edit existing layout
			layoutInfo = this.props.param.layouts[layoutId];

			let selected_icon = layoutInfo.icon;																//set existing icon
			for (let i in icon_list) {
				if (icon_list[i].key == selected_icon) {
					icon_list[i].is_selected = true;
					break;
				}
			}

			if (layoutInfo.bgImage != '' && layoutInfo.bgImage != null && layoutInfo.bgImage != 'null') {
				base64ImageId = layoutInfo.bgImage;

				this.props.receiver.loadImage({
					name: base64ImageId
				});

			} else {
				window.app.hideLoading();
			}

			for (let i in layoutInfo.target) {
				let tempTargetId = layoutInfo.target[i].id;

				switch (layoutInfo.target[i].type) {
					case 'groupIcon':
					case 'groupLabel':
					case 'groupOption':
						if (grouplist.hasOwnProperty(tempTargetId)) {
							grouplist[tempTargetId] = true;
						} else {
							layoutInfo.target.splice(i, 1);
						}
						break;
					case 'sceneIcon':
					case 'sceneLabel':
						if (scenelist.hasOwnProperty(tempTargetId)) {
							scenelist[tempTargetId] = true;
						} else {
							layoutInfo.target.splice(i, 1);
						}
						break;
					case 'layoutIcon':
					case 'layoutLabel':
						if (layoutlist.hasOwnProperty(tempTargetId)) {
							layoutlist[tempTargetId] = true;
						} else {
							layoutInfo.target.splice(i, 1);
						}
						break;
					case 'mpoints':
					case 'mpointsIcon':
					case 'mpointsLabel':
					case 'mpointsAv':
					case 'mpointsMeter':
					case 'mpointsMode':
					case 'mpointsSp':
					case 'mpointsHumSp':
					case 'mpointsTemp':
						if (devicelist.hasOwnProperty(tempTargetId)) {
							devicelist[tempTargetId] = true;
						} else {
							layoutInfo.target.splice(i, 1);
						}
						break;
					case 'reportIcon':
					case 'reportLabel':
						switch (tempTargetId) {
							case 'trend':
								reportlist.trend = true;
								break;
							case 'energy_management':
								reportlist.energy_management = true;
								break;
							case 'water_management':
								reportlist.water_management = true;
								break;
							case 'op_info':
								reportlist.op_info = true;
								break;
							case 'error_info':
								reportlist.error_info = true;
								break;
							default:
							// code block	
						}
						break;
					case 'acsummary':
						acsummarySelected = true;
						break;
					case 'powersummary':
						powersummarySelected = true;
						break;
					default:
					// code block
				}
			}
		} else {
			window.app.hideLoading();
		}

		this.state = {
			icon_list: icon_list,
			base64ImageId: base64ImageId,
			base64Image: base64Image,
			grouplist: grouplist,
			scenelist: scenelist,
			layoutlist: layoutlist,
			devicelist: devicelist,
			reportlist: reportlist,
			acsummarySelected: acsummarySelected,
			powersummarySelected: powersummarySelected,
			layoutInfo: layoutInfo,
			groupSelected: false,
			sceneSelected: false,
			layoutSelected: false,
			mpointsSelected: false,
			reportSelected: false
		}
	}

	handlePrevious = () => {
		window.app.showLoading();
		this.props.receiver.next_component = 'Layout_Editor';
		this.props.receiver.getGroups();
	}

	handleMenuSelected = (type, value) => {
		this.setState({
			groupSelected: false,
			sceneSelected: false,
			layoutSelected: false,
			mpointsSelected: false,
			reportSelected: false
		}, () => {
			this.setState({ [type]: !value });
		});
	}

	handleSelectIcon = (key) => {
		let icon_list = this.state.icon_list;
		for (let i in icon_list) {
			if (icon_list[i].key == key) {
				icon_list[i].is_selected = true;
			} else {
				icon_list[i].is_selected = false;
			}
		}

		let tempLytInfo = this.state.layoutInfo;

		tempLytInfo.icon = key;

		this.setState({
			icon_list: icon_list,
			layoutInfo: tempLytInfo
		})
	}

	handleToggleACEnable = () => {
		this.setState({ acsummarySelected: !this.state.acsummarySelected }, () => {
			let tempLytInfo = this.state.layoutInfo;

			if (this.state.acsummarySelected == true) {
				for (let i in tempLytInfo.target) {
					tempLytInfo.target[i].selectedIcon = false;
				}

				tempLytInfo.target.push({
					"id": "acsummary",
					"type": "acsummary",
					"x": 315,
					"y": 45,
					"size": 2,
					"selectedIcon": true
				});

			} else {
				let index = tempLytInfo.target.findIndex(obj => obj.id == "acsummary");

				tempLytInfo.target.splice(index, 1);
			}

			this.setState({ layoutInfo: tempLytInfo });
		});
	}

	handleTogglePowerEnable = () => {
		this.setState({ powersummarySelected: !this.state.powersummarySelected }, () => {
			let tempLytInfo = this.state.layoutInfo;

			if (this.state.powersummarySelected == true) {
				for (let i in tempLytInfo.target) {
					tempLytInfo.target[i].selectedIcon = false;
				}

				tempLytInfo.target.push({
					"id": "powersummary",
					"type": "powersummary",
					"x": 315,
					"y": 45,
					"size": 2,
					"selectedIcon": true
				});

			} else {
				let index = tempLytInfo.target.findIndex(obj => obj.id == "powersummary");

				tempLytInfo.target.splice(index, 1);
			}

			this.setState({ layoutInfo: tempLytInfo });
		});
	}

	handleFileRead = async (event) => {
		const file = event.target.files[0];
		const base64 = await this.convertBase64(file);

		let tempLytInfo = this.state.layoutInfo;
		tempLytInfo.bgImage = file.name;

		this.setState({
			base64ImageId: file.name,
			base64Image: base64,
			layoutInfo: tempLytInfo
		});
	}

	convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			}

			fileReader.onerror = (error) => {
				reject(error);
			}
		})
	}

	handleToggleGroup = (groupId) => {
		let tempGrpList = this.state.grouplist;

		tempGrpList[groupId] = !this.state.grouplist[groupId];

		this.setState({ grouplist: tempGrpList }, () => {
			let tempLytInfo = this.state.layoutInfo;

			if (this.state.grouplist[groupId] == true) {
				for (let i in tempLytInfo.target) {
					tempLytInfo.target[i].selectedIcon = false;
				}

				tempLytInfo.target.push({
					"id": groupId,
					"type": "groupLabel",
					"x": 10,
					"y": 5,
					"size": 3,
					"selectedIcon": true
				});

				tempLytInfo.target.push({
					"id": groupId,
					"type": "groupIcon",
					"x": 15,
					"y": 30,
					"size": 3,
				});

				tempLytInfo.target.push({
					"id": groupId,
					"type": "groupOption",
					"x": 80,
					"y": 35,
					"size": 3,
				});

			} else {
				for (var i = 0; i < tempLytInfo.target.length; i++) {
					if (tempLytInfo.target[i].id == groupId) {
						//console.log('!!** i: ' + i);
						tempLytInfo.target.splice(i, 1);
						i--;
					}
				}
			}

			this.setState({
				layoutInfo: {
					name: "",
					icon: "",
					bgImage: "",
					target: []
				}
			}, () => {
				this.setState({ layoutInfo: tempLytInfo });
			});
		});
	}

	handleToggleScene = (sceneId) => {
		let tempScnList = this.state.scenelist;

		tempScnList[sceneId] = !this.state.scenelist[sceneId];

		this.setState({ scenelist: tempScnList }, () => {
			let tempLytInfo = this.state.layoutInfo;

			if (this.state.scenelist[sceneId] == true) {
				for (let i in tempLytInfo.target) {
					tempLytInfo.target[i].selectedIcon = false;
				}

				tempLytInfo.target.push({
					"id": sceneId,
					"type": "sceneLabel",
					"x": 10,
					"y": 5,
					"size": 3,
					"selectedIcon": true
				});

				tempLytInfo.target.push({
					"id": sceneId,
					"type": "sceneIcon",
					"x": 15,
					"y": 30,
					"size": 3,
				});

			} else {
				for (var i = 0; i < tempLytInfo.target.length; i++) {
					if (tempLytInfo.target[i].id == sceneId) {
						//console.log('!!** i: ' + i);
						tempLytInfo.target.splice(i, 1);
						i--;
					}
				}
			}

			this.setState({
				layoutInfo: {
					name: "",
					icon: "",
					bgImage: "",
					target: []
				}
			}, () => {
				this.setState({ layoutInfo: tempLytInfo });
			});
		});
	}

	handleToggleLayout = (layoutId) => {
		let tempLytList = this.state.layoutlist;

		tempLytList[layoutId] = !this.state.layoutlist[layoutId];

		this.setState({ layoutlist: tempLytList }, () => {
			let tempLytInfo = this.state.layoutInfo;

			if (this.state.layoutlist[layoutId] == true) {
				for (let i in tempLytInfo.target) {
					tempLytInfo.target[i].selectedIcon = false;
				}

				tempLytInfo.target.push({
					"id": layoutId,
					"type": "layoutLabel",
					"x": 10,
					"y": 5,
					"size": 3,
					"selectedIcon": true
				});

				tempLytInfo.target.push({
					"id": layoutId,
					"type": "layoutIcon",
					"x": 15,
					"y": 30,
					"size": 3,
				});
			} else {
				for (var i = 0; i < tempLytInfo.target.length; i++) {
					if (tempLytInfo.target[i].id == layoutId) {
						//console.log('!!** i: ' + i);
						tempLytInfo.target.splice(i, 1);
						i--;
					}
				}
			}

			this.setState({
				layoutInfo: {
					name: "",
					icon: "",
					bgImage: "",
					target: []
				}
			}, () => {
				this.setState({ layoutInfo: tempLytInfo });
			});
		});
	}

	handleToggleDevice = (deviceId) => {
		let tempDvcList = this.state.devicelist;

		tempDvcList[deviceId] = !this.state.devicelist[deviceId];

		this.setState({ devicelist: tempDvcList }, () => {
			let tempLytInfo = this.state.layoutInfo;

			if (this.state.devicelist[deviceId] == true) {
				for (let i in tempLytInfo.target) {
					tempLytInfo.target[i].selectedIcon = false;
				}

				tempLytInfo.target.push({
					"id": deviceId,
					"type": "mpointsLabel",
					"x": 10,
					"y": 5,
					"size": 3,
					"selectedIcon": true
				});

				tempLytInfo.target.push({
					"id": deviceId,
					"type": "mpointsIcon",
					"x": 15,
					"y": 30,
					"size": 3
				});

				let pointInfo = window.app.state.point_list[deviceId];

				if (pointInfo.hasOwnProperty('av')) {
					tempLytInfo.target.push({
						"id": deviceId,
						"type": "mpointsAv",
						"x": 75,
						"y": 67,
						"size": 3
					});
				}

				if (pointInfo.hasOwnProperty('meter')) {
					tempLytInfo.target.push({
						"id": deviceId,
						"type": "mpointsMeter",
						"x": 15,
						"y": 90,
						"size": 3
					});
				}

				if (pointInfo.hasOwnProperty('mode')) {
					tempLytInfo.target.push({
						"id": deviceId,
						"type": "mpointsMode",
						"x": 75,
						"y": 50,
						"size": 3
					});
				}

				//if(pointInfo.hasOwnProperty('sp')) {	//CANNOT CHECK FOR SP. CHECK CSP/HSP BASED ON ACTUAL MODE. SEE CELL.JS
				if (pointInfo.type == 'Ac') {	//CANNOT CHECK FOR SP. CHECK CSP/HSP BASED ON ACTUAL MODE. SEE CELL.JS
					if (pointInfo.csp != null || pointInfo.hsp != null) {
						tempLytInfo.target.push({
							"id": deviceId,
							"type": "mpointsSp",
							"x": 80,
							"y": 30,
							"size": 3
						});
					}
				}

				if (pointInfo.type == 'Dehumi') {
					if (pointInfo.hum_sp != null) {
						tempLytInfo.target.push({
							"id": deviceId,
							"type": "mpointsHumSp",
							"x": 87,
							"y": 42,
							"size": 3
						});
					}
				}

				if (pointInfo.hasOwnProperty('temp')) {
					tempLytInfo.target.push({
						"id": deviceId,
						"type": "mpointsTemp",
						"x": 70,
						"y": 80,
						"size": 3
					});
				}
			} else {
				for (var i = 0; i < tempLytInfo.target.length; i++) {
					if (tempLytInfo.target[i].id == deviceId) {
						//console.log('!!** i: ' + i);
						tempLytInfo.target.splice(i, 1);
						i--;
					}
				}
			}

			this.setState({
				layoutInfo: {
					name: "",
					icon: "",
					bgImage: "",
					target: []
				}
			}, () => {
				this.setState({ layoutInfo: tempLytInfo });
			});
		});
	}

	handleToggleReport = (reportId) => {
		let tempRptList = this.state.reportlist;

		tempRptList[reportId] = !this.state.reportlist[reportId];

		this.setState({ reportlist: tempRptList }, () => {
			let tempLytInfo = this.state.layoutInfo;

			if (this.state.reportlist[reportId] == true) {
				for (let i in tempLytInfo.target) {
					tempLytInfo.target[i].selectedIcon = false;
				}

				tempLytInfo.target.push({
					"id": reportId,
					"type": "reportLabel",
					"x": 10,
					"y": 5,
					"size": 3,
					"selectedIcon": true
				});

				tempLytInfo.target.push({
					"id": reportId,
					"type": "reportIcon",
					"x": 15,
					"y": 30,
					"size": 3,
				});
			} else {
				for (var i = 0; i < tempLytInfo.target.length; i++) {
					if (tempLytInfo.target[i].id == reportId) {
						//console.log('!!** i: ' + i);
						tempLytInfo.target.splice(i, 1);
						i--;
					}
				}
			}

			this.setState({
				layoutInfo: {
					name: "",
					icon: "",
					bgImage: "",
					target: []
				}
			}, () => {
				this.setState({ layoutInfo: tempLytInfo });
			});
		});
	}

	handleChangeLayoutName = (val) => {
		let tempLytInfo = this.state.layoutInfo;

		tempLytInfo.name = val;

		this.setState({ layoutInfo: tempLytInfo });
	}

	handleRegister = () => {
		let tempLytInfo = this.state.layoutInfo;

		if (tempLytInfo.name == '' || tempLytInfo.name == null) {
			window.app.showToast(this.props.receiver.getString('enter_layout_name'), 3000);
			return;
		}

		if (tempLytInfo.icon == '' || tempLytInfo.icon == null) {
			window.app.showToast(this.props.receiver.getString('select_layout_icon'), 3000);
			return;
		}

		window.app.showLoading();	//successful checks

		for (let i in tempLytInfo.target) {
			if (tempLytInfo.target[i].hasOwnProperty('selectedIcon')) {
				delete tempLytInfo.target[i]['selectedIcon'];
			}
		}

		let layoutId = this.props.param.layout_id;
		let payload = this.props.param.layouts;

		if (payload === undefined) payload = {};

		if (layoutId == null) {
			if (isEmpty(payload)) {
				layoutId = 'layout0'
			} else {
				let lastLytId = Object.keys(payload)[Object.keys(payload).length - 1];

				lastLytId = parseInt(lastLytId.replace('layout', '')) + 1;

				layoutId = 'layout' + lastLytId;
			}
		}

		payload[layoutId] = tempLytInfo;

		this.props.receiver.saveJSONFile({
			name: 'layout_list.json',
			data: payload
		});
	}

	handleDelete = () => {
		let layoutId = this.props.param.layout_id;
		let payload = this.props.param.layouts;

		if (payload.hasOwnProperty(layoutId)) {
			delete payload[layoutId];
		}

		this.props.receiver.saveJSONFile({
			name: 'layout_list.json',
			data: payload
		});
	}

	handleChangePosition = (x, y, index) => {
		// Update the layout info when target cell position is changed
		let layoutInfo = this.state.layoutInfo;

		layoutInfo.target[index].x = x;
		layoutInfo.target[index].y = y;

		console.log('!!!*** device index: ' + layoutInfo.target[index].id + ', new position x: ' + x + ' y: ' + y)

		this.setState({ layoutInfo: layoutInfo });
	}

	handleChangeLayout = (layoutId) => {
		let new_layout_info = this.props.param.layouts[layoutId];
		let base64ImageId = null;

		if (!isEmpty(new_layout_info)) {
			// todo: add animation
			if (new_layout_info.bgImage != '' && new_layout_info.bgImage != null && new_layout_info.bgImage != 'null') {
				//retrieve from controller
				base64ImageId = new_layout_info.bgImage;

				this.props.receiver.loadImage({
					name: base64ImageId
				});

			}

			this.setState({
				layout_info: {},
				base64ImageId: base64ImageId,
				base64Image: null
			}, () => {
				this.setState({ layout_info: new_layout_info });
			});
		}
	}

	handleReport = (reportType) => {
		let today = new Date();
		this.searchDate = today;
		this.searchEndDate = today;
		this.searchPoints = [];
		let searchDetails = {};

		switch (reportType) {
			case 'trend':
				window.app.showLoading();
				this.props.receiver.getTrendPointList();
				break;
			case 'energy_management':
			case 'water_management':
				window.app.showLoading();
				this.reportType = reportType;
				//Alex 20210610 Changed to loadReportSettings.
				//this.props.receiver.readJSONFile({name: 'report_settings.json'});
				this.props.receiver.loadReportSettings();
				break;
			case 'op_info':
				window.app.showLoading();
				let points = Object.keys(window.app.state.point_list);
				let endDate = new Date(this.searchDate);
				endDate.setDate(endDate.getDate() + 1);

				// searchDetails = {"fy":year,"fm":month,"fd":day,"ty":year,"tm":month,"td":day,"points":[point id]}
				searchDetails = {
					fy: this.searchDate.getFullYear(),
					fm: this.searchDate.getMonth() + 1,
					fd: this.searchDate.getDate(),
					ty: endDate.getFullYear(),
					tm: endDate.getMonth() + 1,
					td: endDate.getDate(),
					points: points
				}

				this.props.receiver.getDailyOpTime(searchDetails);
				break;
			case 'error_info':
				window.app.showLoading();
				searchDetails = {
					year: this.searchDate.getFullYear(),
					month: this.searchDate.getMonth() + 1,
					day: this.searchDate.getDate(),
				}

				this.props.receiver.getDailyErrorInfo(searchDetails);
				break;
			default:
		}
	}

	handleSelectedCell = (cellId, cellType) => {
		let tempLytInfo = this.state.layoutInfo;

		for (let i in tempLytInfo.target) {
			tempLytInfo.target[i].selectedIcon = false;
		}

		for (let i in tempLytInfo.target) {
			if (tempLytInfo.target[i].id == cellId) {
				if (tempLytInfo.target[i].type == cellType) {
					tempLytInfo.target[i].selectedIcon = true;
				}
			}
		}

		this.setState({
			layoutInfo: {
				name: "",
				icon: "",
				bgImage: "",
				target: []
			}
		}, () => {
			this.setState({ layoutInfo: tempLytInfo });
		});

	}

	handleSizeInc = (selectedTargetId, selectedTargetType) => {
		let tempLytInfo = this.state.layoutInfo;

		for (let index in tempLytInfo.target) {
			if (selectedTargetId == tempLytInfo.target[index].id) {
				if (selectedTargetType == tempLytInfo.target[index].type) {
					if (tempLytInfo.target[index].size < 7) {
						tempLytInfo.target[index].size = tempLytInfo.target[index].size + 1;
					} else {
						window.app.showToast(this.props.receiver.getString('max_size_reached'), 3000);
					}
				}
			}
		}

		this.setState({ layoutInfo: tempLytInfo });
	}

	handleSizeDec = (selectedTargetId, selectedTargetType) => {
		let tempLytInfo = this.state.layoutInfo;

		for (let index in tempLytInfo.target) {
			if (selectedTargetId == tempLytInfo.target[index].id) {
				if (selectedTargetType == tempLytInfo.target[index].type) {
					if (tempLytInfo.target[index].size > 1) {
						tempLytInfo.target[index].size = tempLytInfo.target[index].size - 1;
					} else {
						window.app.showToast(this.props.receiver.getString('min_size_reached'), 3000);
					}
				}
			}
		}

		this.setState({ layoutInfo: tempLytInfo });
	}

	handlePointInfo = (selectedTargetId, switchState, pInfoType) => {
		let tempLytInfo = this.state.layoutInfo;
		let deviceListTmp = this.state.devicelist;

		if (switchState == false) {		//add
			tempLytInfo.target.push({
				"id": selectedTargetId,
				"type": pInfoType,
				"x": 10,
				"y": 5,
				"size": 3,
				"selectedIcon": true
			});
		} else {						//remove
			for (let index in tempLytInfo.target) {
				if (selectedTargetId == tempLytInfo.target[index].id) {
					if (tempLytInfo.target[index].type == pInfoType) {
						tempLytInfo.target.splice(index, 1);
					}
				}
			}

			let iTmp = tempLytInfo.target.findIndex(obj => obj.id == selectedTargetId);

			if (iTmp == -1) {
				//remove from the selectionList.				
				deviceListTmp[selectedTargetId] = false;
			}
		}

		this.setState({
			layoutInfo: {
				name: "",
				icon: "",
				bgImage: "",
				target: []
			}
		}, () => {
			this.setState({
				layoutInfo: tempLytInfo,
				devicelist: deviceListTmp,
			});
		});
	}

	handleLabelDisplay = (selectedTargetId, showLabel, targetType) => {
		let tempLytInfo = this.state.layoutInfo;
		let groupListTmp = this.state.grouplist;
		let sceneListTmp = this.state.scenelist;
		let layoutListTmp = this.state.layoutlist;
		let deviceListTmp = this.state.devicelist;
		let reportListTmp = this.state.reportlist;

		if (showLabel == false) {		//add
			let labelType = '';

			switch (targetType) {
				case 'group':
					labelType = 'groupLabel';
					break;
				case 'scene':
					labelType = 'sceneLabel';
					break;
				case 'layout':
					labelType = 'layoutLabel';
					break;
				case 'mpoints':
					labelType = 'mpointsLabel';
					break;
				case 'report':
					labelType = 'reportLabel';
					break;
				default:

			}

			tempLytInfo.target.push({
				"id": selectedTargetId,
				"type": labelType,
				"x": 10,
				"y": 5,
				"size": 3,
				"selectedIcon": true
			});
		} else {						//remove
			for (let index in tempLytInfo.target) {
				if (selectedTargetId == tempLytInfo.target[index].id) {
					switch (tempLytInfo.target[index].type) {
						case 'groupLabel':
						case 'sceneLabel':
						case 'layoutLabel':
						case 'mpointsLabel':
						case 'reportLabel':
							tempLytInfo.target.splice(index, 1);
							break;
						default:
					}
				}
			}

			let iTmp = tempLytInfo.target.findIndex(obj => obj.id == selectedTargetId);

			if (iTmp == -1) {
				//remove from the selectionList.				
				switch (targetType) {
					case 'group':
						groupListTmp[selectedTargetId] = false;
						break;
					case 'scene':
						sceneListTmp[selectedTargetId] = false;
						break;
					case 'layout':
						layoutListTmp[selectedTargetId] = false;
						break;
					case 'mpoints':
						deviceListTmp[selectedTargetId] = false;
						break;
					case 'report':
						reportListTmp[selectedTargetId] = false;
						break;
					default:

				}
			}
		}

		this.setState({
			layoutInfo: {
				name: "",
				icon: "",
				bgImage: "",
				target: []
			}
		}, () => {
			this.setState({
				layoutInfo: tempLytInfo,
				grouplist: groupListTmp,
				scenelist: sceneListTmp,
				layoutlist: layoutListTmp,
				devicelist: deviceListTmp,
				reportlist: reportListTmp
			});
		});
	}

	handleIconDisplay = (selectedTargetId, showIcon, targetType) => {
		let tempLytInfo = this.state.layoutInfo;
		let groupListTmp = this.state.grouplist;
		let sceneListTmp = this.state.scenelist;
		let layoutListTmp = this.state.layoutlist;
		let deviceListTmp = this.state.devicelist;
		let reportListTmp = this.state.reportlist;

		if (showIcon == false) {		//add
			let iconType = '';

			switch (targetType) {
				case 'group':
					iconType = 'groupIcon';
					break;
				case 'scene':
					iconType = 'sceneIcon';
					break;
				case 'layout':
					iconType = 'layoutIcon';
					break;
				case 'mpoints':
					iconType = 'mpointsIcon';
					break;
				case 'report':
					iconType = 'reportIcon';
					break;
				default:

			}

			tempLytInfo.target.push({
				"id": selectedTargetId,
				"type": iconType,
				"x": 15,
				"y": 30,
				"size": 3,
				"selectedIcon": true
			});
		} else {						//remove
			for (let index in tempLytInfo.target) {
				if (selectedTargetId == tempLytInfo.target[index].id) {
					switch (tempLytInfo.target[index].type) {
						case 'groupIcon':
						case 'sceneIcon':
						case 'layoutIcon':
						case 'mpointsIcon':
						case 'reportIcon':
							tempLytInfo.target.splice(index, 1);
							break;
						default:
					}
				}
			}

			let iTmp = tempLytInfo.target.findIndex(obj => obj.id == selectedTargetId);

			if (iTmp == -1) {
				//remove from the selectionList.
				switch (targetType) {
					case 'group':
						groupListTmp[selectedTargetId] = false;
						break;
					case 'scene':
						sceneListTmp[selectedTargetId] = false;
						break;
					case 'layout':
						layoutListTmp[selectedTargetId] = false;
						break;
					case 'mpoints':
						deviceListTmp[selectedTargetId] = false;
						break;
					case 'report':
						reportListTmp[selectedTargetId] = false;
						break;
					default:

				}
			}
		}

		this.setState({
			layoutInfo: {
				name: "",
				icon: "",
				bgImage: "",
				target: []
			}
		}, () => {
			this.setState({
				layoutInfo: tempLytInfo,
				grouplist: groupListTmp,
				scenelist: sceneListTmp,
				layoutlist: layoutListTmp,
				devicelist: deviceListTmp,
				reportlist: reportListTmp
			});
		});
	}

	handleOptionDisplay = (selectedTargetId, showIcon, targetType) => {
		let tempLytInfo = this.state.layoutInfo;
		let groupListTmp = this.state.grouplist;

		if (showIcon == false) {		//add
			let iconType = '';

			switch (targetType) {
				case 'group':
					iconType = 'groupOption';
					break;
				default:
			}

			tempLytInfo.target.push({
				"id": selectedTargetId,
				"type": iconType,
				"x": 80,
				"y": 35,
				"size": 3,
				"selectedIcon": true
			});
		} else {						//remove
			for (let index in tempLytInfo.target) {
				if (selectedTargetId == tempLytInfo.target[index].id) {
					switch (tempLytInfo.target[index].type) {
						case 'groupOption':
							tempLytInfo.target.splice(index, 1);
							break;
						default:
					}
				}
			}

			let iTmp = tempLytInfo.target.findIndex(obj => obj.id == selectedTargetId);

			if (iTmp == -1) {
				//remove from the selectionList.
				switch (targetType) {
					case 'group':
						groupListTmp[selectedTargetId] = false;
						break;
					default:

				}
			}
		}

		this.setState({
			layoutInfo: {
				name: "",
				icon: "",
				bgImage: "",
				target: []
			}
		}, () => {
			this.setState({
				layoutInfo: tempLytInfo,
				grouplist: groupListTmp,
			});
		});
	}

	rcvSaveJSONFile(result) {
		if (result.hasOwnProperty('result')) {
			if (result.result == 'OK') {
				if (this.state.base64ImageId != null && this.state.base64Image != null) {
					this.props.receiver.saveImage({
						name: this.state.base64ImageId,
						data: this.state.base64Image
					});
				} else {
					window.app.hideLoading();
					//alert('Layout updated.');
					window.app.showToast(this.props.receiver.getString('layout_updated'), 3000);

					window.app.showLoading();
					this.props.receiver.next_component = 'Layout_Editor';
					this.props.receiver.getGroups();
				}
			} else {
				window.app.hideLoading();
				window.app.showToast(this.props.receiver.getString('json_save_failed'), 3000);
			}
		} else {
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('json_save_failed'), 3000);
		}
	}

	rcvSaveImage(result) {
		if (result.hasOwnProperty('result')) {
			if (result.result == 'OK') {
				window.app.hideLoading();
				window.app.showToast(this.props.receiver.getString('layout_updated'), 3000);
			} else {
				window.app.hideLoading();
				window.app.showToast(this.props.receiver.getString('image_upload_failed'), 3000);
			}
		} else {
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('image_upload_failed'), 3000);
		}

		window.app.showLoading();
		this.props.receiver.next_component = 'Layout_Editor';
		this.props.receiver.getGroups();
	}

	rcvLoadImage(result) {
		if (result.hasOwnProperty('data')) {
			let imageString = result.data;

			this.setState({
				base64Image: imageString
			});
		} else {
			if (result.hasOwnProperty('result')) {
				if (result.result == 'NG') {
					window.app.showToast(this.props.receiver.getString('load_image_failed'), 3000);
				}
			}
		}
		window.app.hideLoading();
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height - 60,
			overflow: 'auto',
		}

		let button_style = {
			width: '80%',
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			userSelect: 'none'
		}

		let selectedTargetId = null;
		let selectedTargetName = null;
		let selectedTargetType = null;
		let selectedDeviceType = null;
		let targetType = null;

		let spSwitch = false;
		let humSpSwitch = false;
		let tempSwitch = false;
		let modeSwitch = false;
		let avSwitch = false;
		let meterSwitch = false;

		let showLabel = false;
		let showIcon = false;
		let showOption = false;

		let tempExist = false;
		let avExist = false;
		let meterExist = false;

		for (let i in this.state.layoutInfo.target) {
			if (this.state.layoutInfo.target[i].hasOwnProperty('selectedIcon')) {
				if (this.state.layoutInfo.target[i].selectedIcon == true) {
					selectedTargetId = this.state.layoutInfo.target[i].id;

					switch (this.state.layoutInfo.target[i].type) {
						//case 'group':
						case 'groupIcon':
						case 'groupLabel':
						case 'groupOption':
							selectedTargetName = this.props.receiver.getString(this.props.param.groups[selectedTargetId].name);
							selectedTargetType = this.state.layoutInfo.target[i].type;
							targetType = 'group';
							break;
						case 'sceneIcon':
						case 'sceneLabel':
							selectedTargetName = this.props.param.scenes[selectedTargetId].name;
							selectedTargetType = this.state.layoutInfo.target[i].type;
							targetType = 'scene';
							break;
						case 'layoutIcon':
						case 'layoutLabel':
							selectedTargetName = this.props.param.layouts[selectedTargetId].name;
							selectedTargetType = this.state.layoutInfo.target[i].type;
							targetType = 'layout';
							break;
						case 'mpoints':
						case 'mpointsIcon':
						case 'mpointsLabel':
						case 'mpointsAv':
						case 'mpointsMeter':
						case 'mpointsMode':
						case 'mpointsSp':
						case 'mpointsHumSp':
						case 'mpointsTemp':
							selectedTargetName = window.app.state.point_list[selectedTargetId].name;

							selectedTargetType = this.state.layoutInfo.target[i].type;					//mpointIcon / mpointsLabel

							selectedDeviceType = window.app.state.point_list[selectedTargetId].type;    //point type

							targetType = 'mpoints';

							if (window.app.state.point_list[selectedTargetId].hasOwnProperty('temp')) tempExist = true;
							if (window.app.state.point_list[selectedTargetId].hasOwnProperty('av')) avExist = true;
							if (window.app.state.point_list[selectedTargetId].hasOwnProperty('meter')) meterExist = true;
							break;
						case 'reportIcon':
						case 'reportLabel':
							selectedTargetType = this.state.layoutInfo.target[i].type;
							targetType = 'report';

							switch (selectedTargetId) {
								case 'trend':
									selectedTargetName = this.props.receiver.getString('trend_graph');
									break;
								case 'energy_management':
									selectedTargetName = this.props.receiver.getString('energy_management');
									break;
								case 'water_management':
									selectedTargetName = this.props.receiver.getString('water_management');
									break;
								case 'op_info':
									selectedTargetName = this.props.receiver.getString('operation_info_report');
									break;
								case 'error_info':
									selectedTargetName = this.props.receiver.getString('err_reporting_report');
									break;
								default:
								// code block	
							}
							break;
						case 'acsummary':
							selectedTargetName = this.props.receiver.getString('acsummary');

							selectedTargetType = 'summary';

							targetType = 'summary';
							break;
						case 'powersummary':
							selectedTargetName = this.props.receiver.getString('powersummary');

							selectedTargetType = 'summary';

							targetType = 'summary';
							break;
						default:
						// code block
					}

					if (selectedTargetType != 'summary') {
						for (let index in this.state.layoutInfo.target) {
							if (selectedTargetId == this.state.layoutInfo.target[index].id) {
								switch (this.state.layoutInfo.target[index].type) {
									case 'groupLabel':
									case 'sceneLabel':
									case 'layoutLabel':
									case 'mpointsLabel':
									case 'reportLabel':
										showLabel = true;
										break;
									case 'groupIcon':
									case 'sceneIcon':
									case 'layoutIcon':
									case 'mpointsIcon':
									case 'reportIcon':
										showIcon = true;
										break;
									case 'groupOption':
										showOption = true;
										break;
									case 'mpointsAv':
										avSwitch = true;
										break;
									case 'mpointsMeter':
										meterSwitch = true;
										break;
									case 'mpointsMode':
										modeSwitch = true;
										break;
									case 'mpointsSp':
										spSwitch = true;
										break;
									case 'mpointsHumSp':
										humSpSwitch = true;
										break;
									case 'mpointsTemp':
										tempSwitch = true;
										break;
									default:

								}
							}
						}
					}
				}
			}
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.layout_id == null ? this.props.receiver.getString('add_new_layout') : this.props.receiver.getString('edit_layout')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div className='noScrollBar' style={{ width: '100%', height: '90%' }}>
						<div id='leftMenuBar' className='noScrollBar' style={{ width: '20%', height: '100%', display: 'inline-block', overflow: 'auto' }}>
							{/* Left Menu Bar, scrollable */}
							{/* <div style={{ textAlign: 'left' }}>
									<span style={{ fontSize: '20px' }}> {this.props.receiver.getString('layout_icon')} </span>
								</div>
								
								<div style={{ marginTop: 20 }} > */}
							<div>
								<Icon_Carousel id={'point_icon_carousel'} style={{ 'width': '100%' }} icon_list={this.state.icon_list} handleSelectIcon={this.handleSelectIcon} />
							</div>

							{/* <div style={{ textAlign: 'left', marginTop: 20 }}>
									<span style={{ fontSize: '20px' }}> {this.props.receiver.getString('layout_name')} </span>
								</div>  */}

							<div style={{ textAlign: 'left', marginTop: 20 }}>
								<Editbox id='layout_name' style={{ width: '80%', margin: 'auto' }} placeholder={this.props.receiver.getString('layout_name')} inputType='text' onChange={(event) => this.handleChangeLayoutName(event.target.value)} value={this.state.layoutInfo.name} />
							</div>

							<div style={{ textAlign: 'left', marginTop: 20 }}>
								<span style={{ fontSize: '20px' }}> {this.props.receiver.getString('upload_bg_image')} </span>
							</div>

							<div style={{ textAlign: 'left' }}>
								<input
									id="file"
									ref="file"
									type="file"
									name="file"
									className="upload-file"
									onChange={this.handleFileRead}
									encType="multipart/form-data"
									accept="image/png"
								/>
							</div>

							{/* Groups - group */}
							<div style={{ textAlign: 'left', marginTop: 20 }} onClick={() => this.handleMenuSelected('groupSelected', this.state.groupSelected)} >
								<span style={{ fontSize: this.state.groupSelected ? '25px' : '20px', fontWeight: this.state.groupSelected ? 'bold' : 'normal' }}> {this.props.receiver.getString('group')} </span>
							</div>

							<div style={{ display: this.state.groupSelected ? 'block' : 'none' }}>
								{this.state.grouplist && Object.keys(this.state.grouplist).map((groupId) => {
									let group = this.props.param.groups[groupId];
									let icon = getIcon(group.icon);
									return (
										<div style={button_style} onClick={() => this.handleToggleGroup(groupId)} >
											<div style={{ display: 'inline-block', width: '80%', textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }}>
												<div style={{ width: 25, display: this.state.grouplist[groupId] == true ? 'inline-block' : 'none' }}>
													<img src={check} style={{ width: 25 }} />
												</div>
												<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
													<img src={icon} style={{ width: 30 }} />
												</div>
												<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5 }}>
													<span>{this.props.receiver.getString(group.name)}</span>
												</div>
											</div>
										</div>
									)
								})}
							</div>

							{/* Scenes - scene */}
							<div style={{ textAlign: 'left', marginTop: 20 }} onClick={() => this.handleMenuSelected('sceneSelected', this.state.sceneSelected)} >
								<span style={{ fontSize: this.state.sceneSelected ? '25px' : '20px', fontWeight: this.state.sceneSelected ? 'bold' : 'normal' }}> {this.props.receiver.getString('scene')} </span>
							</div>

							<div style={{ display: this.state.sceneSelected ? 'block' : 'none' }}>
								{this.state.scenelist && Object.keys(this.state.scenelist).map((sceneId) => {
									let scene = this.props.param.scenes[sceneId];
									let icon = getSceneIcon(scene.icon);
									return (
										<div style={button_style} onClick={() => this.handleToggleScene(sceneId)}>
											<div style={{ display: 'inline-block', width: '80%', textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }}>
												<div style={{ width: 25, display: this.state.scenelist[sceneId] == true ? 'inline-block' : 'none' }}>
													<img src={check} style={{ width: 25 }} />
												</div>
												<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
													<img src={icon} style={{ width: 30 }} />
												</div>
												<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5 }}>
													<span>{scene.name}</span>
												</div>
											</div>
										</div>
									)
								})}
							</div>

							{/* Layouts - layout */}
							<div style={{ textAlign: 'left', marginTop: 20 }} onClick={() => this.handleMenuSelected('layoutSelected', this.state.layoutSelected)} >
								<span style={{ fontSize: this.state.layoutSelected ? '25px' : '20px', fontWeight: this.state.layoutSelected ? 'bold' : 'normal' }}> {this.props.receiver.getString('layout')} </span>
							</div>

							<div style={{ display: this.state.layoutSelected ? 'block' : 'none' }}>
								{this.state.layoutlist && Object.keys(this.state.layoutlist).map((layoutId) => {
									let layout = this.props.param.layouts[layoutId];
									let icon = getIcon(layout.icon);
									return (
										<div style={button_style} onClick={() => this.handleToggleLayout(layoutId)} >
											<div style={{ display: 'inline-block', width: '80%', textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }}>
												<div style={{ width: 25, display: this.state.layoutlist[layoutId] == true ? 'inline-block' : 'none' }}>
													<img src={check} style={{ width: 25 }} />
												</div>
												<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
													<img src={icon} style={{ width: 30 }} />
												</div>
												<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5 }}>
													<span>{layout.name}</span>
												</div>
											</div>
										</div>
									)
								})}
							</div>

							{/* Devices - mpoints */}
							<div style={{ textAlign: 'left', marginTop: 20 }} onClick={() => this.handleMenuSelected('mpointsSelected', this.state.mpointsSelected)} >
								<span style={{ fontSize: this.state.mpointsSelected ? '25px' : '20px', fontWeight: this.state.mpointsSelected ? 'bold' : 'normal' }}> {this.props.receiver.getString('devices')} </span>
							</div>

							<div style={{ display: this.state.mpointsSelected ? 'block' : 'none' }}>
								{this.state.devicelist && Object.keys(this.state.devicelist).map((pointId) => {
									let pointInfo = window.app.state.point_list[pointId];
									let icon = null;
									if (!isEmpty(pointInfo)) {
										icon = getIcon(pointInfo.icon);
										return (
											<div style={button_style} onClick={() => this.handleToggleDevice(pointId)}>
												<div style={{ display: 'inline-block', width: '80%', textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }}>
													<div style={{ width: 25, display: this.state.devicelist[pointId] == true ? 'inline-block' : 'none' }}>
														<img src={check} style={{ width: 25 }} />
													</div>
													<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
														<img src={icon} style={{ width: 30 }} />
													</div>
													<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5 }}>
														<span>{pointInfo.name}</span>
													</div>
												</div>
											</div>
										)
									}
								})}
							</div>

							{/* Reports - reports */}
							{/* <div style={{ textAlign: 'left', marginTop: 20 }} onClick={() => this.handleMenuSelected('reportSelected', this.state.reportSelected)} >
									<span style={{ fontSize: this.state.reportSelected ? '25px' : '20px', fontWeight: this.state.reportSelected ? 'bold' : 'normal' }}> {this.props.receiver.getString('report')} </span>
								</div>
								
								<div style={{ display: this.state.reportSelected ? 'block' : 'none' }}>
									<div style={button_style} onClick={()=>this.handleToggleReport('trend')}>
										<div style={{display: 'inline-block', width: '80%', textAlign: 'left',verticalAlign: 'top', marginLeft:10, paddingTop: 15, paddingBottom: 15}}>
											<div style={{width: 25, display: this.state.reportlist['trend'] == true ? 'inline-block' : 'none' }}>
												<img src={check} style={{width: 25}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 5}}>
												<img src={trend_icon} style={{width: 30}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5}}>
												<span>{this.props.receiver.getString('trend_graph')}</span>
											</div>
										</div>
									</div>
									
									<div style={button_style} onClick={()=>this.handleToggleReport('energy_management')}>
										<div style={{display: 'inline-block', width: '80%', textAlign: 'left',verticalAlign: 'top', marginLeft:10, paddingTop: 15, paddingBottom: 15}}>
											<div style={{width: 25, display: this.state.reportlist['energy_management'] == true ? 'inline-block' : 'none' }}>
												<img src={check} style={{width: 25}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 5}}>
												<img src={energy_icon} style={{width: 30}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5}}>
												<span>{this.props.receiver.getString('energy_management')}</span>
											</div>
										</div>
									</div>
									
									<div style={button_style} onClick={()=>this.handleToggleReport('water_management')}>
										<div style={{display: 'inline-block', width: '80%', textAlign: 'left',verticalAlign: 'top', marginLeft:10, paddingTop: 15, paddingBottom: 15}}>
											<div style={{width: 25, display: this.state.reportlist['water_management'] == true ? 'inline-block' : 'none' }}>
												<img src={check} style={{width: 25}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 5}}>
												<img src={water_icon} style={{width: 30}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5}}>
												<span>{this.props.receiver.getString('water_management')}</span>
											</div>
										</div>
									</div>
									
									<div style={button_style} onClick={()=>this.handleToggleReport('op_info')}>
										<div style={{display: 'inline-block', width: '80%', textAlign: 'left',verticalAlign: 'top', marginLeft:10, paddingTop: 15, paddingBottom: 15}}>
											<div style={{width: 25, display: this.state.reportlist['op_info'] == true ? 'inline-block' : 'none' }}>
												<img src={check} style={{width: 25}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 5}}>
												<img src={op_info_icon} style={{width: 30}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5}}>
												<span>{this.props.receiver.getString('operation_info_report')}</span>
											</div>
										</div>
									</div>
								
									<div style={button_style} onClick={()=>this.handleToggleReport('error_info')}>
										<div style={{display: 'inline-block', width: '80%', textAlign: 'left',verticalAlign: 'top', marginLeft:10, paddingTop: 15, paddingBottom: 15}}>
											<div style={{width: 25, display: this.state.reportlist['error_info'] == true ? 'inline-block' : 'none' }}>
												<img src={check} style={{width: 25}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 5}}>
												<img src={error_info_icon} style={{width: 30}} />
											</div>
											<div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 10, paddingTop: 5}}>
												<span>{this.props.receiver.getString('err_reporting_report')}</span>
											</div>
										</div>
									</div>
								</div> */}

							{/* AC Summary - acsummary */}
							{/* <div style={{ textAlign: 'left', marginTop: 20 }}>
									&nbsp;&nbsp;
									<Switch style={{display: 'inline-block'}} is_enabled={this.state.acsummarySelected} handleToggleSwitch={this.handleToggleACEnable}/>
									&nbsp;&nbsp;&nbsp;&nbsp;
									<span style={{ fontSize: '20px' }}> {this.props.receiver.getString('acsummary')} </span>
								</div> */}

							{/* Power Summary - powersummary */}
							{/* <div style={{ textAlign: 'left', marginTop: 20, marginBottom: 10 }}>
									&nbsp;&nbsp;
									<Switch style={{display: 'inline-block'}} is_enabled={this.state.powersummarySelected} handleToggleSwitch={this.handleTogglePowerEnable}/>
									&nbsp;&nbsp;&nbsp;&nbsp;
									<span style={{ fontSize: '20px' }}> {this.props.receiver.getString('powersummary')} </span>
								</div> */}

							<div> &nbsp; </div><div> &nbsp; </div><div> &nbsp; </div>
						</div>

						<div id='rightMainScreen' style={{ width: '80%', height: '100%', display: 'inline-block' }}>
							<div id='rightScreenEdit' style={{
								width: '99%',
								height: '80%',
								display: 'inline-block',
								//backgroundImage: `url(${this.state.base64Image})`, 
								//backgroundRepeat: 'no-repeat',
								//backgroundAttachment: 'local',
								border: '1px solid ',
								borderStyle: 'solid',
								position: 'relative',
								overflow: 'auto'
							}}>
								<img style={{ position: 'absolute', display: this.state.base64Image == null ? 'none' : 'block' }} src={this.state.base64Image} />
								{this.state.layoutInfo.target.map((targetInfo, index) => {
									return (
										<Target_Cell
											key={index}
											index={index}
											width={this.props.width}
											groups={this.props.param.groups} // Need to retrieve groups and scenes 
											scenes={this.props.param.scenes} // before coming to Layout page
											layouts={this.props.param.layouts} // List of layouts
											layout_id={this.props.param.layout_id} //current layout id, for navigation
											layout_info={this.state.layoutInfo} // current layout detail
											target_info={targetInfo} // current target detail
											is_movable={true} // allow or disallow target cell to move
											handleChangePosition={this.handleChangePosition}
											handleChangeLayout={this.handleChangeLayout}
											handleReport={this.handleReport}
											handleSelectedCell={this.handleSelectedCell}
											receiver={this.props.receiver}
											content_handler={this.props.content_handler}
										/>
									)
								})}
							</div>

							<div id='rightBottomSubMenu' style={{ width: '100%', height: '20%', display: 'inline-block', backgroundColor: 'white' }}>
								<div style={{ height: '100%', width: '100%', display: selectedTargetId == null ? 'none' : 'table' }}>
									<div style={{ height: '20%', display: 'table-row' }}>
										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											<span style={{ fontSize: '20px', marginRight: '10px' }}> {selectedTargetName} </span>
										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'center' }}>

										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'center' }}>

										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'right' }}>
											<span style={{ fontSize: '20px', marginRight: '10px' }}>
												{this.props.receiver.getString('icon_size')}:
												<button style={{ height: '20px', width: '30px', fontWeight: 'bold', backgroundColor: this.props.colours.button_bg, color: this.props.colours.button_font, textAlign: 'center', border: '0', borderRadius: '5px', marginLeft: '10px', marginRight: '10px' }} onClick={() => this.handleSizeInc(selectedTargetId, selectedTargetType)}> + </button>
												/
												<button style={{ height: '20px', width: '30px', fontWeight: 'bold', backgroundColor: this.props.colours.button_bg, color: this.props.colours.button_font, textAlign: 'center', border: '0', borderRadius: '5px', marginLeft: '10px', marginRight: '10px' }} onClick={() => this.handleSizeDec(selectedTargetId, selectedTargetType)}> - </button>
											</span>
										</div>
									</div>

									<div style={{ height: '20%', display: 'table-row' }}>
										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{/* TEXT LABEL SELECTION */}
											<span style={{ display: selectedTargetType == 'summary' ? 'none' : 'inline' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={showLabel} handleToggleSwitch={() => this.handleLabelDisplay(selectedTargetId, showLabel, targetType)} />

												{this.props.receiver.getString('text_label')}
											</span>
										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{/* ICON SELECTION */}
											<span style={{ display: selectedTargetType == 'summary' ? 'none' : 'inline' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={showIcon} handleToggleSwitch={() => this.handleIconDisplay(selectedTargetId, showIcon, targetType)} />

												{this.props.receiver.getString('icon')}
											</span>
										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{/* MODE SELECTION AV */}
											<span style={{ display: selectedDeviceType == 'Ac' ? 'inline' : 'none' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={modeSwitch} handleToggleSwitch={() => this.handlePointInfo(selectedTargetId, modeSwitch, 'mpointsMode')} />

												{this.props.receiver.getString('mode')}
											</span>
										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{/* SETPOINT SELECTION AC*/}
											<span style={{ display: selectedDeviceType == 'Ac' ? 'inline' : 'none' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={spSwitch} handleToggleSwitch={() => this.handlePointInfo(selectedTargetId, spSwitch, 'mpointsSp')} />

												{this.props.receiver.getString('sp')}
											</span>
										</div>
									</div>

									<div style={{ height: '20%', display: 'table-row' }}>
										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{ tempExist &&
											<span style={{ display: tempExist ? 'inline' : 'none' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={tempSwitch} handleToggleSwitch={() => this.handlePointInfo(selectedTargetId, tempSwitch, 'mpointsTemp')} />

												{this.props.receiver.getString('temp')}
											</span>
											}
											
											{ selectedDeviceType == 'Dehumi' &&
												<span style={{ display: selectedDeviceType == 'Dehumi' ? 'inline' : 'none' }}>
													<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={humSpSwitch} handleToggleSwitch={() => this.handlePointInfo(selectedTargetId, humSpSwitch, 'mpointsHumSp')} />

													{this.props.receiver.getString('hum_sp')}
												</span>
											}
										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{/* AV SELECTION */}
											<span style={{ display: avExist ? 'inline' : 'none' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={avSwitch} handleToggleSwitch={() => this.handlePointInfo(selectedTargetId, avSwitch, 'mpointsAv')} />

												{this.props.receiver.getString('av')}
											</span>
										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{/* METER SELECTION */}
											<span style={{ display: meterExist ? 'inline' : 'none' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={meterSwitch} handleToggleSwitch={() => this.handlePointInfo(selectedTargetId, meterSwitch, 'mpointsMeter')} />

												{this.props.receiver.getString('meter')}
											</span>
										</div>

										<div style={{ width: '25%', display: 'table-cell', textAlign: 'left' }}>
											{/* OPTIONAL DATA SELECTION Groups */}
											<span style={{ display: targetType == 'group' ? 'inline' : 'none' }}>
												<Switch style={{ display: 'inline-block', marginRight: '10px' }} is_enabled={showOption} handleToggleSwitch={() => this.handleOptionDisplay(selectedTargetId, showOption, targetType)} />

												{this.props.receiver.getString('optional_data')}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}